import React from 'react';
import { Button } from './Button';

interface EmptyStateProps {
  icon: React.ComponentType<{ size?: number }>;
  heading: string;
  message: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon: Icon, heading, message, action }) => {
  const containerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px 20px',
    textAlign: 'center',
    minHeight: '400px',
  };

  const iconWrapperStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '24px',
    color: 'var(--color-light-grey)',
  };

  const headingStyle: React.CSSProperties = {
    fontSize: '20px',
    fontWeight: 600,
    fontFamily: 'var(--font-family)',
    color: 'var(--color-dark-grey)',
    margin: '0 0 12px 0',
  };

  const messageStyle: React.CSSProperties = {
    fontSize: '14px',
    fontFamily: 'var(--font-family)',
    color: 'var(--color-dark-grey)',
    margin: '0 0 24px 0',
    maxWidth: '400px',
    lineHeight: '1.5',
  };

  const actionStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
  };

  return (
    <div style={containerStyle}>
      <div style={iconWrapperStyle}>
        <Icon size={48} />
      </div>
      <h3 style={headingStyle}>{heading}</h3>
      <p style={messageStyle}>{message}</p>
      {action && (
        <div style={actionStyle}>
          <Button variant="primary" onClick={action.onClick}>
            {action.label}
          </Button>
        </div>
      )}
    </div>
  );
};
